import React from 'react'
import PrimaryButton from './PrimaryButton'

interface PrimaryButtonGroupProps {
    variant?: 'primary' | 'secondary' | 'strike' | 'outlined'
    fullWidthOnMobile?: boolean
    buttons: Array<{
        label: string
        onClick: () => void
        startIcon?: React.ReactNode
        endIcon?: React.ReactNode,
        isSelected?: boolean
    }>
    height?: number
}

const PrimaryButtonGroup: React.FC<PrimaryButtonGroupProps> = ({
    variant = 'primary',
    fullWidthOnMobile = false,
    buttons,
}) => {
    return (
        <div
            className={`inline-flex ${fullWidthOnMobile ? 'sx:w-full' : 'md:w-auto'}`}
        >
            {buttons.map((btn, index) => {
                let roundedClass = ''
                if (index === 0) roundedClass = 'rounded-l-[12px] rounded-r-none'
                else if (index === buttons.length - 1) roundedClass = 'rounded-r-[12px] rounded-l-none'
                else roundedClass = 'rounded-none'

                return (
                    <PrimaryButton
                        key={index}
                        variant={btn.isSelected ? 'primary' : variant}
                        onClick={btn.onClick}
                        startIcon={btn.startIcon}
                        endIcon={btn.endIcon}
                        className={`-ml-[1px] first:ml-0 ${roundedClass} flex-1`}
                    >
                        {btn.label}
                    </PrimaryButton>
                )
            })}
        </div>
    )
}

export default PrimaryButtonGroup;
